import { type Anmelder } from '../api.ts';
import { Kopf } from '../teile/Geruest.tsx';
import { Partnerzahlung } from '../teile/Partnerzahlung.tsx';

/* RECHNUNGEN BEZAHLEN, EIGENE SEITE (.260)
 * ORIGINALTEXT MARVIN (30.09.2026)
 *   „packe beide bereiche zum zahlen unter "abrechnung". und löse das bei
 *    "Rechnung prüfen" heraus. das will ich separieren, falls ich das durch
 *    rechte mal unterschiedlichen personen zuweise." */
export default function RechnungenBezahlen({ ich }: { ich: Anmelder }) {
  return (
    <>
      <Kopf titel="Rechnungen bezahlen" weg="Rechnungen der Partner, einzeln oder gebündelt, abgeglichen mit dem Konto" />
      <div className="inhalt">
        <Partnerzahlung ich={ich} />
      </div>
    </>
  );
}
